export const translationLivechat_sv_part3 = {
  livechatAvatarUploading: "Laddar upp...",
  livechatAvatarUploaded: "Bild uppladdad",
  livechatAvatarUploadFailed: "Uppladdning misslyckades",
  livechatDisplayNameRequired: "Visningsnamn krävs.",
  livechatSaveProfile: "Spara profil",
  livechatSaving: "Sparar...",
  livechatClose: "Stäng",
  livechatCancel: "Avbryt",
  livechatSettingsModalTitleLive: "Livechat-inställningar för live-miljö",
  livechatSettingsModalTitleTest: "Livechat-inställningar för testmiljö",
  livechatSettingsModalEyebrow: "{chatbotId} · {env}-miljö",
  livechatSettingsLoading: "Laddar inställningar...",
  livechatSettingsWebhook: "Webhook",
  livechatSettingsEnabledByAdmin: "Aktiverad av administratör",
  livechatSettingsDisabledByAdmin: "Inaktiverad av administratör",
  livechatSettingsConfigured: "Konfigurerad",
  livechatSettingsNotConfigured: "Inte konfigurerad",
  livechatSettingsUnavailable: "Inte tillgänglig",
  livechatSettingsAttachmentRetention: "Dagar för lagring av bilagor",
  livechatSettingsTimezone: "Tidszon för arbetstider",
  livechatSettingsManualAvailability: "Tillgänglighetsläge",
  livechatSettingsManualAuto: "Följ arbetstider",
  livechatSettingsManualLive: "Alltid online",
  livechatSettingsManualOffline: "Alltid offline",
  livechatSettingsTranslationMode: "Livechat-översättning",
  livechatSettingsTranslationOff: "Av",
  livechatSettingsTranslationManual: "Besökaren kan översätta",
  livechatSettingsTranslationAuto: "Automatisk översättning",
  livechatSettingsTranslationHelp:
    "Gäller bara agentmeddelanden i chatboten. Automatisk översättning använder konversationens AI-identifierade språk och faller tillbaka på chatbotens språk.",
  livechatSettingsShowLogo: "Visa livechat-knappen i chattrubrikfältet",
  livechatSettingsShowLogoHelp: "Headset-knappen som besökare använder för att öppna livechat.",
  livechatSettingsHideHeaderButtonLabel: "Låt besökare starta en livechat från knappen",
  livechatSettingsHideHeaderButtonHelp:
    "När avstängt kan besökare inte själva starta en livechat från rubrikfältet. AI-utlösta överlämningar och kontaktformulär med livechat fungerar fortfarande, och knappen visas under en aktiv livechat så att den kan avslutas.",
  livechatSettingsWorkingHours: "Arbetstider",
  livechatSettingsAddHours: "Lägg till tider",
  livechatSettingsNoHours: "Inga tider",
  livechatSettingsRemove: "Ta bort",
  livechatSettingsSave: "Spara inställningar",
  livechatSettingsSaving: "Sparar...",
  livechatSettingsRetentionInteger: "Dagar för lagring av bilagor måste vara ett heltal.",
  livechatWeekdayMonday: "Måndag",
  livechatWeekdayTuesday: "Tisdag",
  livechatWeekdayWednesday: "Onsdag",
  livechatWeekdayThursday: "Torsdag",
  livechatWeekdayFriday: "Fredag",
  livechatWeekdaySaturday: "Lördag",
  livechatWeekdaySunday: "Söndag",
  livechatAvailabilityDisabled: "Inaktiverad",
  livechatAvailabilityManualLive: "Satt online manuellt",
  livechatAvailabilityManualOffline: "Satt offline manuellt",
  livechatAvailabilityAlwaysOn: "Inga arbetstider angivna, alltid online",
  livechatAvailabilityWithinHours: "Inom arbetstider",
  livechatAvailabilityOutsideHours: "Utanför arbetstider",
  livechatEnvironmentWordLive: "Live",
  livechatEnvironmentWordTest: "Test",
  livechatRelativeJustNow: "just nu",
  livechatRelativeSecondsAgo: "{count}s sedan",
  livechatRelativeMinutesAgo: "{count}m sedan",
  livechatRelativeHoursAgo: "{count}h sedan",
  livechatRelativeDaysAgo: "{count}d sedan",
  livechatDurationSeconds: "{count}s",
  livechatDurationMinutes: "{count}m",
  livechatDurationHoursMinutes: "{hours}h {minutes}m",
  livechatDurationHours: "{count}h",
  livechatDurationDays: "{count}d",
  livechatWaitingForLabel: "Väntar",
  livechatActiveForLabel: "Aktiv",
  livechatClosedAgoLabel: "Stängd",
  livechatVisitorTitleFallback: "Besökare",
  livechatNewBadge: "Ny",
  livechatComposerKeyboardHint: "Enter för att skicka · Skift+Enter för ny rad",
  livechatRemoveAttachment: "Ta bort bilaga",
  livechatAttachFiles: "Bifoga filer",
  livechatDropFilesHint: "Släpp filerna för att bifoga dem",
  livechatInsertEmoji: "Infoga emoji",
  livechatNoSessionTipsTitle: "Ingen session vald",
  livechatNoSessionTipsHint:
    "Välj en session från listan till vänster, eller byt flik för att se väntande, aktiva eller stängda konversationer.",
  livechatNoSessionsHeadline: "Allt lugnt här",
  livechatNoSessionsHintWaiting:
    "Inga kunder väntar just nu. Nya konversationer visas automatiskt.",
  livechatNoSessionsHintActive:
    "Du har inga aktiva konversationer. Byt till Väntar för att ta upp en.",
  livechatNoSessionsHintClosed: "Inga stängda konversationer ännu under det här filtret.",
  livechatNoSessionsHintDefault: "Inga sessioner matchar de valda filtren.",
  livechatNoSearchResultsHeadline: "Inga träffar",
  livechatNoSessionsHintSearch:
    'Inga konversationer matchar "{query}" under det här filtret. Prova ett annat sökord eller byt flik.',
  livechatSearchSessionsPlaceholder: "Sök konversationer, ID, besökare eller kunddata...",
  livechatSearchSessionsAria: "Sök livechat-konversationer",
  livechatSearchMatchLabel: "Sökträff",
  livechatClearSearch: "Rensa sökning",
  livechatHeaderAvailabilityLabel: "Tillgänglighet",
  livechatHeaderAvailabilityLive: "Online",
  livechatHeaderAvailabilityOffline: "Offline",
  livechatHeaderAvailabilityLoading: "Laddar…",
  livechatAvailabilityToggleLabel: "Sätt livechat online eller offline för {chatbotId}",
  livechatAvailabilityToggleHint:
    "Manuell åsidosättning. Välj \u201cFölj arbetstider\u201d i Inställningar för att använda schemat istället.",
  livechatHeaderEnvLabel: "Miljö",
  livechatHeaderChatbotLabel: "Chatbot",
  livechatVisitorOtherSessionsCount: "{count} fler sessioner från den här besökaren",
  livechatVisitorOtherSessionsCountSingular: "1 fler session från den här besökaren",
  livechatHideOtherSessions: "Dölj",
  livechatShowOtherSessions: "Visa alla",
  livechatLastUpdated: "Senast uppdaterad",
  livechatSettingsButton: "Inställningar",
  livechatSettingsForChatbot: "Livechat-inställningar för {chatbotId}",
  livechatSettingsChooseChatbot: "Välj vilken chatbot du vill konfigurera",
  livechatSettingsNoChatbots: "Inga chatbotar tillgängliga",
  livechatSettingsSectionAvailability: "Tillgänglighet",
  livechatSettingsSectionAvailabilityHelp:
    "Styr när besökare kan starta en livechat med den här chatboten.",
  livechatSettingsManualAvailabilityHelp:
    "Följ arbetstider använder schemat nedan. Alltid online eller Alltid offline åsidosätter det tills du ändrar det igen.",
  livechatSettingsWorkingHoursHelp:
    "Livechat är online under dessa tidsintervall när arbetstider följs.",
  livechatSettingsWorkingHoursIgnored:
    "Arbetstider används inte när tillgängligheten är satt till Alltid online eller Alltid offline.",
  livechatSettingsSectionWidget: "Chatt-widget",
  livechatSettingsSectionWidgetHelp: "Hur besökare når livechat från chatboten.",
  livechatSettingsSectionTranslation: "Översättning",
  livechatSettingsSectionData: "Datalagring",
  livechatSettingsAttachmentRetentionHelp:
    "Filer uppladdade i livechattar raderas efter det här många dagar.",
  livechatSettingsWorkingHoursNoneSet:
    "Inga tider angivna: livechat är online dygnet runt. Lägg till tider för att begränsa det.",
  livechatSettingsSlotInvalid: "Varje arbetstidsintervall behöver en sluttid efter starttiden.",
  livechatFilterHint: "Filtrera konversationer efter chatbot",
  livechatFilterSelectedOfTotal: "{count} av {total} chatbotar",
  livechatFilterAllInScope: "Alla chatbotar i {scope}",
  livechatFilterSearchPlaceholder: "Sök chatbotar…",
  livechatFilterNoMatches: "Inga chatbotar matchar din sökning.",
  livechatFilterOnly: "Bara",
  livechatFilterOnlyChatbot: "Bara {chatbot}",
  livechatVerifiedMetadata: "Verifierad kunddata",
  livechatVerifiedMetadataHint:
    "Signerat av kundens webbplats och verifierat av oss, så det kan litas på.",
  livechatRoutedTo: "Routad till",
  livechatAcceptedBy: "Accepterad av",
  livechatGroupsButton: "Grupper",
  livechatGroupsTitle: "Livechat-grupper",
  livechatGroupsDescription:
    'Grupper är team av agenter som ett kontaktformulär kan routa chattar till, t.ex. "Back Office". Medlemmar löses upp när en chatt anländer, så du kan ändra listan dagligen. Grupper delas över alla chatbotar i organisationen.',
  livechatGroupsEmpty:
    "Inga grupper ännu. Skapa en för att routa kontaktformulärschattar till ett team.",
  livechatGroupsNew: "Ny grupp",
  livechatGroupsLoadFailed: "Kunde inte ladda grupper.",
  livechatGroupName: "Gruppnamn",
  livechatGroupNamePlaceholder: "Back Office",
  livechatGroupNameRequired: "Ge gruppen ett namn.",
  livechatGroupMembers: "Medlemmar",
  livechatGroupMembersCount: "{count} medlemmar",
  livechatGroupMembersOne: "1 medlem",
  livechatGroupNoCandidates: "Inga användare hittades i organisationen.",
  livechatGroupUnknownMember: "Okänd användare (inte längre i organisationen)",
  livechatGroupSave: "Spara grupp",
  livechatGroupCreate: "Skapa grupp",
  livechatGroupDelete: "Ta bort grupp",
  livechatGroupDeleteConfirm:
    "Ta bort den här gruppen? Formulär som routar till den faller tillbaka till den allmänna kön.",
  livechatGroupSaveFailed: "Kunde inte spara gruppen.",
  livechatGroupDeleteFailed: "Kunde inte ta bort gruppen.",
  livechatGroupNameTaken: "Det finns redan en grupp med det namnet.",
  livechatGroupsClose: "Stäng",
  livechatGroupsSelectHint: "Välj en grupp för att redigera dess namn och medlemmar.",
  livechatRoutingTimeLeft: "{time} kvar för de routade agenterna",
  livechatRoutingFallbackTimeout: "inget svar från de routade agenterna, öppen för alla",
  livechatRoutingFallbackNoOnline: "ingen routad agent var online, öppen för alla",
  livechatRoutingFallbackNoAgents: "ingen routad agent har en livechat-profil här, öppen för alla",
  livechatSettingsSectionRouting: "Routade chattar",
  livechatSettingsSectionRoutingHelp:
    "Kontaktformulär kan routa chattar till en livechat-grupp. Medan minst en medlem är online ser bara gruppen chatten; efter tidsgränsen öppnas den för alla. Den här inställningen gäller hela organisationen.",
  livechatSettingsRoutingTimeout: "Falla tillbaka till alla efter (minuter)",
  livechatSettingsRoutingTimeoutHelp:
    "Hur länge en routad chatt väntar på gruppen innan alla agenter ser den. 1 till 60 minuter, standard 3.",
  livechatSettingsRoutingTimeoutInvalid:
    "Routing-tidsgränsen måste vara ett heltal mellan 1 och 60.",
  livechatBulkHoursTitle: "Tillämpa öppettider på flera chatbotar",
  livechatBulkHoursHelp:
    "Kopiera öppettiderna och tidszonen som visas ovan. Andra osparade inställningar ingår inte.",
  livechatBulkHoursTargets: "Välj chatbotar",
  livechatBulkHoursClear: "Rensa urval",
  livechatBulkHoursSelectAll: "Välj alla",
  livechatBulkHoursPreview: "Ersätt öppettider på {count} chatbotar",
  livechatBulkHoursPreserve:
    "Manuella tillgänglighetsåsidosättningar gäller fortfarande. Inaktiverade chatbotar förblir inaktiverade. Övriga inställningar är oförändrade.",
  livechatBulkHoursFailed:
    "Kunde inte bekräfta uppdateringen. Kontrollera inställningarna innan du försöker igen.",
  livechatBulkHoursSaved: "Öppettider tillämpade på de valda chatbotarna.",
  livechatBulkHoursApply: "Tillämpa på {count} chatbotar",
  livechatBulkHoursReview: "Granska valda chatbotar",
  livechatBulkHoursTargetsFailed:
    "Kunde inte ladda chatbotar för den aktiva organisationen. Stäng och öppna det här avsnittet igen för att försöka på nytt.",
};
